window.dataVoid = '[{"i":"0","l":"0","ia":"404.jpg","ib":"2914456da65a37d0015f2c7280e924fe.jpeg","ic":"b585d9d4866a8ed4cf4a3ac04b171311.jpeg","di":"0","iv":"  ","d":"","t":" ","v":"Aucun résultat ","hac":"0","ap":"0"}]';

function createTerrainItem(terrainData,vars,NbrReq,TypeReq) {
   
  
    const id = terrainData.i;
    const url = vars[0];
    const addPanier = vars[8];
     const liker = vars[2];
    const cout  = moneyFormat(terrainData.t);
    var d = sanctificationLITEenc(terrainData.d);
        var dtt = terrainData.d;
    var l = sanctificationLITE(terrainData.l);
     var hac = terrainData.hac;
     var ap = terrainData.ap;
     var tprop = NotShowNull(" - ",terrainData.tp);
     var commune = StringNotNull(terrainData.v);
     var imgSourceJson = terrainData.ia;
     var qrtier = StringNotNull(terrainData.qrt);
     /////
     if(imgSourceJson.length > 0)
     {
     var imgSrc = url_terrain_path+''+imgSourceJson;
     var imgSrcMobile = url_terrain_path+''+imgSourceJson;   
     }
     else
     {
     var imgSrc =  app_img_url+'noimgxl.jpg'; 
     var imgSrcMobile = app_img_url+'noimgxl.jpg'; 
     }
    
     /////
     if(terrainData.itl)
     {
     var tl = terrainData.itl;   
     }
     else
     {
     var tl = "";   
     }
     var piece = "piece";
    //var idpanier = terrainData.idp/// ompossible
    var df =  d.substring(0, 10);
  const template1 = `<div class="col-md-4 col-sm-6 col-12 item" id="${terrainData.i}">
                                <div class="single_new_arrive">
                                    <div class="sna_img" >
                                        <a href="${app_url+'T/'+id+'/'+urldecodeSanitaire(commune)+'-'+urldecodeSanitaire(terrainData.di)+'-M2'}" class="icon open_quickview"  ondblclick="seeTerrain('${url}','${id}','${ terrainData.p}','${l}','${ terrainData.t}','${d}')" tabindex="1">
                                        <img loading="lazy"  class="prd_img" src="${imgSrc}" alt="product"  >
                                        </a>
                                        <div class="prodcut_hovcont">
                                            <a href="${app_url+'T/'+id+'/'+urldecodeSanitaire(commune)+'-'+urldecodeSanitaire(terrainData.di)+'-M2'}" class="icon open_quickview"  ondblclick="seeTerrain('${url}','${id}','${ terrainData.p}','${l}','${ terrainData.t}','${d}')" tabindex="0">
                                               <i class="icon-search-left"></i>
                                            </a>
                                            <a href="javascript:void(0)" class="icon" onclick="loveTerrain('${url}','${id}','${ terrainData.p}','${terrainData.l}','${terrainData.t}')" tabindex="0">
                                                <i class="icon-heart"></i>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="sna_content">
                                        <a href="${app_url+'T/'+id+'/'+urldecodeSanitaire(commune)+'-'+urldecodeSanitaire(terrainData.di)+'-M2'}">
                                            <h4>${terrainData.di+" m2"+MySubstring(tprop,12)}</h4>
                                        </a>
                                        <div class="ratprice">
                                            <div class="price">
                                                <span class="org_price">${cout}</span>
                                                <span class="prev_price"></span>
                                            </div>
                                            <div class="rating">
                                                <div class="d-flex align-items-center justify-content-start">
                                                ${MySubstring(commune,11)}
                                                    <div class="rating_star d-none">
                                                        <span><i class="las la-star"></i></span>
                                                        <span><i class="las la-star"></i></span>
                                                        <span><i class="las la-star"></i></span>
                                                        <span><i class="las la-star"></i></span>
                                                        <span><i class="las la-star"></i></span>
                                                    </div>
                                                    <p class="rating_count"><i class="fa-regular fa-eye"></i> ${hac} | <i class="fa-regular fa-heart"></i> ${ap} </p>
                                                </div>
                                            </div>
                                             
                                        </div>
                                        <div class="product_adcart">
                                            <button class="default_btn" onclick="openTerrain('${url}','${id}','${terrainData.ia}','${terrainData.di}','${commune}','${terrainData.t}','${d}')"><i class="las la-phone-volume"></i> ${addPanier} </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
  
  `;
  
  
   const template2 = `
    <div class="single_list_product item">
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="list_product_img">
                                            <div class="lp_img">
                                                <a href="${app_url+'T/'+id+'/'+urldecodeSanitaire(commune)+'-'+urldecodeSanitaire(terrainData.di)+'-M2'}">
                                                    <img loading="lazy"  src="${imgSrc}" alt="product">
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="product_content">
                                            <a href="${app_url+'T/'+id+'/'+urldecodeSanitaire(commune)+'-'+urldecodeSanitaire(terrainData.di)+'-M2'}">
                                                <h5>${terrainData.di+" m2"+MySubstring(tprop,75)}</h5>
                                            </a>
                                            <div class="ratprice">
                                                <div class="price">
                                                    <span class="org_price">${cout}</span>
                                                    <span class="prev_price"></span>
                                                </div>
                                                <div class="">
                                                    <div class="d-flex align-items-center justify-content-start">
                                                     ${MySubstring(commune,50)}  
                                                         <div class="rating_star ms-2">
                                                            <span><i class="las la-star"></i></span>
                                                            <span><i class="las la-star"></i></span>
                                                            <span><i class="las la-star"></i></span>
                                                            <span><i class="las la-star"></i></span>
                                                            <span><i class="las la-star"></i></span>
                                                            <p class="rating_count d-inline"><i class="fa-regular fa-eye"></i> ${hac} | <i class="fa-regular fa-heart"></i> ${ap} </p>
                                                        </div> 
                                               
                                                    </div>
                                                    
                                                </div>
                                             
                                            </div>
                                             <p class="">
                                              
                                            </p>
                                            
                                            <p class="product_list_desc">
                                              ${MySubstring(dtt,140)} 
                                            </p>
                                            
                                            <div class="product_list_btns">
                                                <button class="list_product_btn" onclick="GopayTerrain('${url}','${id}','${ terrainData.p}','${l}','${ terrainData.t}')"><span class="icon"><i class="icon-cart"></i></span> ${addPanier} </button>
                                                <button class="list_product_btn wish" onclick="loveTerrain('${url}','${id}','${ terrainData.p}')"><span class="icon"><i class="icon-heart"></i></span> ${liker}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
  
  
  
   `;
   
   
   const templateTmobile = `

   <div class="col-md-4 col-sm-6 col-6 pb-4 item" id="${terrainData.i}">
   
    
                        <div class="topr_img" onclick="location.href='${app_url+'T/'+id+'/'+urldecodeSanitaire(commune)+'-'+urldecodeSanitaire(terrainData.di)+'-M2'}'">
                            <a href="javascript:void(0)">
                                <img loading="lazy"  src="${imgSrcMobile}" alt="product">
                            </a>
                            <span class="tag opacity-100 d-none">${hac}</span>
                            <span class="tag opacity-50 mt-4 d-none">${ap}</span>
                        </div>
                        <div class="topr_content bg-gradient-light">
                            <a href="javascript:void(0)">
                                <h4>${terrainData.di+" m2"+ NiceSubstr(14, tprop)}</h4> 
                            </a>
                            <div class="price">
                                <span class="org_price">${cout}</span>
                                <span class="prev_price"></span>
                                <span class="rating_count"><i class="fa-regular fa-cart"></i> </span>
                            </div>
                            <div class="rating">
                                <div class="d-flex align-items-center justify-content-start">
                               ${commune.substring(0, 14)}
                                    <div class="rating_star d-none">
                                        <span><i class="las la-star"></i></span>
                                        <span><i class="las la-star"></i></span>
                                        <span><i class="las la-star"></i></span>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
    
   
  
   
  
   `;
   
   ////// Immobilier Vente Mobile
   const templateIV1m = `

   <div class="col-md-4 col-sm-6 col-6 pb-4 item" id="${terrainData.i}">
   
    
                        <div class="topr_img" onclick="location.href='${app_url+'M/'+id+'/'+urldecodeSanitaire(commune)+'-'+tl+'-'+urldecodeSanitaire(terrainData.di)+'-'+ accord(terrainData.di,piece)}'">
                            <a href="javascript:void(0)">
                                <img loading="lazy"  src="${url_immobilier_path+'' + terrainData.ia}" alt="product">
                            </a>
                            <span class="tag opacity-100 d-none">${hac}</span>
                            <span class="tag opacity-50 mt-4 d-none">${ap}</span>
                        </div>
                        <div class="topr_content bg-gradient-light">
                            <a href="javascript:void(0)">
                                <h4 class="d-none"><span> (${tl}) </span>${terrainData.di+" P "}</h4>
                                <h4>  ${MySubstring(l, 14)}</h4>  
                            </a>
                            <div class="price">
                                <span class="org_price">${cout}</span>
                                <span class="prev_price"></span>
                                <span class="rating_count"><i class="fa-regular fa-cart"></i> </span>
                            </div>
                            <div class="rating">
                                <div class="d-flex align-items-center justify-content-start">
                               ${commune.substring(0, 14)}
                                    <div class="rating_star d-none">
                                        <span><i class="las la-star"></i></span>
                                        <span><i class="las la-star"></i></span>
                                        <span><i class="las la-star"></i></span>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
    
   
  
   
  
   `;
   
      ////// Immobilier Location Mobile
   const templateIV2m = `

   <div class="col-md-4 col-sm-6 col-6 pb-4 item" id="${terrainData.i}">
   
    
                        <div class="topr_img" onclick="location.href='${app_url+'M/'+id+'/'+urldecodeSanitaire(commune)+'-'+tl+'-'+urldecodeSanitaire(terrainData.di)+'-'+ accord(terrainData.di,piece)}'">
                            <a href="javascript:void(0)">
                                <img loading="lazy"  src="${url_immobilier_path+'' + terrainData.ia}" alt="product">
                            </a>
                            <span class="tag opacity-100 d-none">${hac}</span>
                            <span class="tag opacity-50 mt-4 d-none">${ap}</span>
                        </div>
                        <div class="topr_content bg-gradient-light">
                            <a href="javascript:void(0)">
                               <h4><span> (${tl}) </span>${terrainData.di+" P "}</h4> 
                            </a>
                            <div class="price">
                                <span class="org_price">${cout}</span>
                                <span class="prev_price"></span>
                                <span class="rating_count"><i class="fa-regular fa-cart"></i> </span>
                            </div>
                            <div class="rating">
                                <div class="d-flex align-items-center justify-content-start">
                               ${commune.substring(0, 14)}
                                    <div class="rating_star d-none">
                                        <span><i class="las la-star"></i></span>
                                        <span><i class="las la-star"></i></span>
                                        <span><i class="las la-star"></i></span>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
    
   
  
   
  
   `;
   
   
     const template_void = `<div class="col-md-4 col-sm-6 col-12 item" id="${terrainData.i}">
                                <div class="single_new_arrive">
                                    <div class="sna_img">
                                        <img loading="lazy"  class="prd_img" src="${url_terrain_path+'' + terrainData.ia}" alt="product">
                                       
                                    </div>
                                    <div class="sna_content">
                                       
                                        <div class="ratprice">
                                            <div class="price">
                                               
                                                <span class="prev_price"></span>
                                            </div>
                                            <div class="rating">
                                                <div class="d-flex align-items-center justify-content-start">
                                                ${commune}
                                                    
                                                  
                                                </div>
                                            </div>
                                             
                                        </div>
                                        <div class="product_adcart">
                                            <button class="default_btn"><i class="las la-info"></i> ${commune} </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
  
  `;
 
   
  ////////////////// TMP IMMOBILIER VENTE  
     const templateIV1 = `<div class="col-md-4 col-sm-6 col-12 item" id="${terrainData.i}">
                                <div class="single_new_arrive">
                                    <div class="sna_img">
                                        <img loading="lazy"  class="prd_img" src="${url_immobilier_path+'' + terrainData.ia}" alt="product">
                                        <div class="prodcut_hovcont">
                                            <a href="${app_url+'M/'+id+'/'+urldecodeSanitaire(commune)+'-'+tl+'-'+urldecodeSanitaire(terrainData.di)+'-'+ accord(terrainData.di,piece)}" class="icon open_quickview"  ondblclick="seeTerrain('${url}','${id}','${ terrainData.p}','${l}','${ terrainData.t}','${d}')" tabindex="0">
                                               <i class="icon-search-left"></i>
                                            </a>
                                            <a href="javascript:void(0)" class="icon" onclick="loveTerrain('${url}','${id}','${ terrainData.p}','${terrainData.l}','${terrainData.t}')" tabindex="0">
                                                <i class="icon-heart"></i>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="sna_content">
                                        <a href="${app_url+'M/'+id+'/'+urldecodeSanitaire(commune)+'-'+tl+'-'+urldecodeSanitaire(terrainData.di)+'-'+accord(terrainData.di,piece)}">
                                            <p><strong>${MySubstring(l, 20)}</strong></p> 
                                        </a>
                                        <div class="ratprice">
                                            <div class="price">
                                                <span class="org_price">${cout}</span>
                                                <span class="prev_price"></span>
                                            </div>
                                            <div class="rating">
                                                <div class="d-flex align-items-center justify-content-start">
                                                ${commune}
                                                    <div class="rating_star d-none">
                                                        <span><i class="las la-star"></i></span>
                                                        <span><i class="las la-star"></i></span>
                                                        <span><i class="las la-star"></i></span>
                                                        <span><i class="las la-star"></i></span>
                                                        <span><i class="las la-star"></i></span>
                                                    </div>
                                                    <p class="rating_count"><i class="fa-regular fa-eye"></i> ${hac} | <i class="fa-regular fa-heart"></i> ${ap} </p>
                                                </div>
                                            </div>
                                             
                                        </div>
                                        <div class="product_adcart">
                                            <button class="default_btn" onclick="openImmobilier('${url}','${id}','${terrainData.ia}','${terrainData.di}','${commune}','${terrainData.t}','${d}')"><i class="las la-phone-volume"></i> ${addPanier} </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
  
  `;
  
  
  /////////////////////TMP IMMOBILIER VENTE PAGE 2
  
     const templateIVP2 = `
    <div class="single_list_product item">
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="list_product_img">
                                            <div class="lp_img">
                                                <a href="${app_url+'M/'+id+'/'+urldecodeSanitaire(commune)+'-'+tl+'-'+urldecodeSanitaire(terrainData.di)+'-'+ accord(terrainData.di,piece)}">
                                                    <img loading="lazy"  src="${url_immobilier_path+'' + terrainData.ia}" alt="product">
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="product_content">
                                            <a href="${app_url+'M/'+id+'/'+urldecodeSanitaire(commune)+'-'+tl+'-'+urldecodeSanitaire(terrainData.di)+'-'+ accord(terrainData.di,piece)}">
                                                <h5>${MySubstring(l, 25)}</h5>
                                                 
                                            </a>
                                            <div class="ratprice">
                                                <div class="price">
                                                    <span class="org_price">${cout}</span>
                                                    <span class="prev_price"></span>
                                                </div>
                                                <div class="">
                                                    <div class="d-flex align-items-center justify-content-start">
                                                     ${MySubstring(commune,30)} (${MySubstring(qrtier,20)})    
                                                         <div class="rating_star ms-2">
                                                            <span><i class="las la-star"></i></span>
                                                            <span><i class="las la-star"></i></span>
                                                            <span><i class="las la-star"></i></span>
                                                            <span><i class="las la-star"></i></span>
                                                            <span><i class="las la-star"></i></span>
                                                            <p class="rating_count d-inline"><i class="fa-regular fa-eye"></i> ${hac} | <i class="fa-regular fa-heart"></i> ${ap} </p>
                                                        </div> 
                                               
                                                    </div>
                                                    
                                                </div>
                                             
                                            </div>
                                             <p class="">
                                              
                                            </p>
                                            
                                            <p class="product_list_desc">
                                              ${MySubstring(dtt,140)} 
                                            </p>
                                            
                                            <div class="product_list_btns">
                                                <button class="list_product_btn" onclick="openImmobilier('${url}','${id}','${terrainData.ia}','${terrainData.di}','${commune}','${terrainData.t}','${d}')"><span class="icon"><i class="icon-cart"></i></span> ${addPanier} </button>
                                                <button class="list_product_btn wish" onclick="loveTerrain('${url}','${id}','${ terrainData.p}','${terrainData.l}','${terrainData.t}')"><span class="icon"><i class="icon-heart"></i></span> ${liker}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
  
  
  
   `;
   
   
     /////////////////////TMP IMMOBILIER LOCATION PAGE 2
  
     const templateILP2 = `
    <div class="single_list_product item">
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="list_product_img">
                                            <div class="lp_img">
                                                <a href="${app_url+'M/'+id+'/'+urldecodeSanitaire(commune)+'-'+tl+'-'+urldecodeSanitaire(terrainData.di)+'-'+ accord(terrainData.di,piece)}">
                                                    <img loading="lazy"  src="${url_immobilier_path+'' + terrainData.ia}" alt="product">
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="product_content">
                                            <a href="${app_url+'M/'+id+'/'+urldecodeSanitaire(commune)+'-'+tl+'-'+urldecodeSanitaire(terrainData.di)+'-'+ accord(terrainData.di,piece)}">
                                                <h5><strong>${MySubstring(l, 25)}</strong></h5>
                                                 
                                            </a>
                                            <div class="ratprice">
                                                <div class="price">
                                                    <span class="org_price">${cout}</span>
                                                    <span class="prev_price"></span>
                                                </div>
                                                <div class="">
                                                    <div class="d-flex align-items-center justify-content-start">
                                                     ${MySubstring(commune,30)} (${MySubstring(qrtier,20)})    
                                                         <div class="rating_star ms-2">
                                                            <span><i class="las la-star"></i></span>
                                                            <span><i class="las la-star"></i></span>
                                                            <span><i class="las la-star"></i></span>
                                                            <span><i class="las la-star"></i></span>
                                                            <span><i class="las la-star"></i></span>
                                                            <p class="rating_count d-inline"><i class="fa-regular fa-eye"></i> ${hac} | <i class="fa-regular fa-heart"></i> ${ap} </p>
                                                        </div> 
                                               
                                                    </div>
                                                    
                                                </div>
                                             
                                            </div>
                                             <p class="">
                                              
                                            </p>
                                            
                                            <p class="product_list_desc">
                                              ${MySubstring(dtt,140)} 
                                            </p>
                                            
                                            <div class="product_list_btns">
                                                <button class="list_product_btn" onclick="openImmobilier('${url}','${id}','${terrainData.ia}','${terrainData.di}','${commune}','${terrainData.t}','${d}')"><span class="icon"><i class="icon-cart"></i></span> ${addPanier} </button>
                                                <button class="list_product_btn wish" onclick="loveTerrain('${url}','${id}','${ terrainData.p}','${terrainData.l}','${terrainData.t}')"><span class="icon"><i class="icon-heart"></i></span> ${liker}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
  
  
  
   `;
  
    ////////////////// TMP IMMOBILIER LOCATION  
     const templateIV2 = `<div class="col-md-4 col-sm-6 col-12 item" id="${terrainData.i}">
                                <div class="single_new_arrive">
                                    <div class="sna_img">
                                        <img loading="lazy"  class="prd_img" src="${url_immobilier_path+'' + terrainData.ia}" alt="product">
                                        <div class="prodcut_hovcont">
                                            <a href="${app_url+'M/'+id+'/'+urldecodeSanitaire(commune)+'-'+tl+'-'+urldecodeSanitaire(terrainData.di)+'-'+ accord(terrainData.di,piece)}" class="icon open_quickview"  ondblclick="seeTerrain('${url}','${id}','${ terrainData.p}','${l}','${ terrainData.t}','${d}')" tabindex="0">
                                               <i class="icon-search-left"></i>
                                            </a>
                                            <a href="javascript:void(0)" class="icon" onclick="loveTerrain('${url}','${id}','${ terrainData.p}','${terrainData.l}','${terrainData.t}')" tabindex="0">
                                                <i class="icon-heart"></i>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="sna_content">
                                        <a href="${app_url+'M/'+id+'/'+urldecodeSanitaire(commune)+'-'+tl+'-'+urldecodeSanitaire(terrainData.di)+'-'+accord(terrainData.di,piece)}">
                                            <p><strong>${MySubstring(l, 20)}</strong></p> 
                                        </a>
                                        <div class="ratprice">
                                            <div class="price">
                                                <span class="org_price">${cout}</span>
                                                <span class="prev_price"></span>
                                            </div>
                                            <div class="rating">
                                                <div class="d-flex align-items-center justify-content-start">
                                                ${commune}
                                                    <div class="rating_star d-none">
                                                        <span><i class="las la-star"></i></span>
                                                        <span><i class="las la-star"></i></span>
                                                        <span><i class="las la-star"></i></span>
                                                        <span><i class="las la-star"></i></span>
                                                        <span><i class="las la-star"></i></span>
                                                    </div>
                                                    <p class="rating_count"><i class="fa-regular fa-eye"></i> ${hac} | <i class="fa-regular fa-heart"></i> ${ap} </p>
                                                </div>
                                            </div>
                                             
                                        </div>
                                        <div class="product_adcart">
                                            <button class="default_btn" onclick="openImmobilier('${url}','${id}','${terrainData.ia}','${terrainData.di}','${commune}','${terrainData.t}','${ sanctificationEnc(urldecodeSanitaire(d))}')"><i class="las la-phone-volume"></i> ${addPanier} </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
  
  `;
   
   
   
   
   
   /////////////////////////////////// FIN IMM VENTE
   
  ///<p class="rating_count"> <i class="fa-regular fa-eye"></i> (150)</p>
  //<span class="rating_count"><i class="fa-regular fa-heart"></i> (0)</span>

  let item = document.createElement('div');
  var ww = window.innerWidth;
  var wh = window.innerHeight;
    //console.log("=======Screen======"+ww);
///////////////////////////////////////////////////////////////// CLASSIFICATION DES PAGES PAR REQUETTE
if(TypeReq == "terrain")
{

if(NbrReq > 0)
{
if(ww > 450 )
{
  if(PageMode == 1)
  {
    item.innerHTML = template1.trim();  
  }
  else
  {
    item.innerHTML = template2.trim(); 
  }

}
else
{
    const listeBase = document.getElementById("liste_des_produits");
    listeBase.classList.add("row");
      if(PageMode == 1)
  {
    item.innerHTML = templateTmobile.trim();  
  }
  else
  {
    item.innerHTML = template2.trim(); 
  }
    
}
}
else
{
  item.innerHTML = template_void.trim();   
}

}
else if (TypeReq == "ImmLocation")
{

if(NbrReq > 0)
{
if(ww > 450 )
{
  if(PageMode == 1)
  {
    item.innerHTML = templateIV2.trim();  
  }
  else
  {
    item.innerHTML = templateILP2.trim(); 
  }

}
else
{
    const listeBase = document.getElementById("liste_des_produits");
    listeBase.classList.add("row");
    item.innerHTML = templateIV2m.trim();    
}
}
else
{
  item.innerHTML = template_void.trim();   
}

}
else if (TypeReq == "ImmVente")
{

if(NbrReq > 0)
{
if(ww > 450 )
{
  if(PageMode == 1)
  {
    item.innerHTML = templateIV1.trim();  
  }
  else
  {
    item.innerHTML = templateIVP2.trim(); 
  }

}
else
{
    const listeBase = document.getElementById("liste_des_produits");
    listeBase.classList.add("row");
    //item.innerHTML = templateIV1m.trim(); 
    //item.innerHTML = templateIVP2.trim(); 
    if(PageMode == 1)
  {
    item.innerHTML = templateIV1m.trim();  
  }
  else
  {
    item.innerHTML = templateIVP2.trim(); 
  }
       
}
}
else
{
  item.innerHTML = template_void.trim();   
}

}
else
{
    
}
/////////////////////////////////////////////////////////// FIN CLASSIFICATION

  return item.firstChild;
}

function nextHandler(pageIndex) {
    //alert(reqt);
    var key =  token_api_client;
    var searchPrice = searchPrice;
    //var Postdata = new URLSearchParams("email="+key+"&password=pw");
    //var Postdata  = {"st_via":""+st_via+"","dfdx":"dds"}; JSON.stringify(Postdata)
    var Postdata = new URLSearchParams(document.location.search);
    
    
                
    //alert(searchPrice);
    
      //console.log("=======mode======"+reqt);
  return fetch(app_url+'ajax/client/api.php?req='+reqt+'&token_api_client='+key+'&searchCout='+searchPrice+'&searchVille='+searchVille, { method: "POST", body: Postdata })
    .then(response => response.json())
    .then((data) => {
      let frag = document.createDocumentFragment();
      let itemsPerPage = MyPGCD(data.length) ;
      
      //console.log(" INIT... ======== "+MyPGCD(data.length));
      
       var DataSource = data.length;
          window.titreInfo = document.getElementById("resultat_total_api");
          var titreInfoM = document.getElementById("resultat_total_apiM");
      if(data.length < itemsPerPage)
      {
       titreInfo.innerHTML = "<strong>"+ data.length+"</strong>  "+accord(data.length,TypeRequetteName)+" "+accord(data.length,"trouvé")+ "";
       titreInfoM.innerHTML = "<strong>"+ data.length+"</strong> "+accord(data.length,TypeRequetteName)+" "+accord(data.length,"trouvé")+ ""; 
         
        if(data.length == 0)
        {
        data = JSON.parse(dataVoid);
        ///return false;
         DataSource = 0;
        //console.log(itemsPerPage+"==========DATA INI LEN==============="+data.length);
   
        }
        else
        {
         DataSource = data.length;
        
      
        }
        itemsPerPage = data.length;
  
      }
      else
      {
        titreInfo.innerHTML = "<strong>"+ data.length+"</strong> "+accord(data.length,TypeRequetteName)+" "+accord(data.length,"trouvé")+ ""; 
        titreInfoM.innerHTML = "<strong>"+ data.length+"</strong> "+accord(data.length,TypeRequetteName)+" "+accord(data.length,"trouvé")+ "";   
      }
      
         //PubCall();
      
   
        
      
      
      let totalPages = Math.ceil(data.length / itemsPerPage);
      let offset = pageIndex * itemsPerPage;
	   //console.log("===========+++ "+DataSource+"==++++============");
	  ini = offset;
	 
	  // walk over the movie items for the current page and add them to the fragment
	   //console.log(itemsPerPage+"==========DATA LEN==============="+data.length);
      for (let i = offset, len = offset + itemsPerPage; i < len; i++) {
        let movie = data[i];
		console.log(DataSource);
      
          let item = createTerrainItem(movie,localVars,DataSource,TypeRequette);    
        

        frag.appendChild(item);
      }

      let hasNextPage = pageIndex < totalPages - 1;

      return this.append(Array.from(frag.childNodes))
        // indicate that there is a next page to load
        .then(() => hasNextPage);
      
          
    });
}

if(iasterrain)
{
window.ias = new InfiniteAjaxScroll('.productlist', {
  item: '.item',
  next: nextHandler,
  pagination: true,
});

}


/////////////////////////////////////////////////////////////////

function createRDVform(url,id,p,vars) {
  const template = `<div class="product_quickview" id="xoxo">
    <div class="prodquick_wrap position-relative">
        <div class="close_quickview" id="closepop">
            <i class="las la-times"></i>
        </div>
        <div class="row">
            <div class="col-lg-6">
                    <div class="col-md-12 text-center"> <h4>PRISE DE RENDEZ-VOUS POUR LA VISITE</h4> </div>
            
            <div class="col-md-12 d-none">
                                    <div class="single_billing_inp">
                                        <label>Vous "</label>
                                        <select class="nice_select" style="display: none;">
                                            <option>select gender</option>
                                            <option selected=""></option>
                                            <option>Un Homme</option>
                                            <option>Une Femme</option>
                                        </select><div class="nice-select nice_select" tabindex="0"><span class="current">Male</span><ul class="list"><li data-value="select gender" class="option">select gender</li><li data-value="Male" class="option selected">Male</li><li data-value="Female" class="option">Female</li><li data-value="Other" class="option">Other</li></ul></div>
                                    </div>
                                </div>
                                
                                
                                <div class="col-md-12">
                                    <div class="single_billing_inp">
                                        <label>Moi ${UserInfo[0]} je souhaite être contacté sur numéro de téléphone ${UserInfo[1]} avant et après le Rendez-vous </label>
                                     
                                    </div>
                                </div>
                                
                                
                                
                                <div class="col-md-12">
                                    <div class="single_billing_inp">
                                        <label>Date du Rendez-vous</label>
                                        <input type="date" id="RDVdateJS"  />
                                    </div>
                                </div>
                                
                                 <div class="col-md-12">
                                    <div class="single_billing_inp">
                                        <label>Avez-vous une suggestion pour le rendez-vous ?</label>
                                        <textarea class="form-control" id="RDVtxtJS" rows="3"></textarea>
                                
                                    </div>
                                </div>
                                
                                
                               
                                
                 <div class="product_buttons text-center">
                        <a href="javascript:void(0)" id="btnConfirmeRdv" class="default_btn me-sm-3 me-2 px-2 px-lg-4"><i class="lar la-handshake"></i><span id="btnConfirmeRdvTxt"> </span>  </a>
                        
                    </div>
              
            </div>
            <div class="col-lg-6">
                <div class="product_info_wrapper">
                    <div class="product_base_info">
                        <h1 id="titre"> ${id} </h1>
                        <div class="rating d-none">
                            <div class="d-flex align-items-center">
                                <div class="rating_star">
                                
                                    <span><i class="las la-star"></i></span>
                                    <span><i class="las la-star"></i></span>
                                    <span><i class="las la-star"></i></span>
                                    <span><i class="las la-star"></i></span>
                                    <span><i class="las la-star"></i></span>
                                </div>
                                <p class="rating_count">50 Reviews</p>
                            </div>
                        </div>
                        <div class="product_other_info d-none">
                            <p><span class="text-semibold">Availability:</span><span class="text-green">In
                                    Stock</span></p>
                            <p><span class="text-semibold">Brand:</span>Bata</p>
                            <p><span class="text-semibold">Category:</span>Clothing</p>
                            <p><span class="text-semibold">SKU:</span>BE45VGRT</p>
                        </div>
                        <div class="price mt-3 mb-3 d-flex align-items-center">
                            <span class="prev_price ms-0" id="focout"></span>
                            <span class="org_price ms-2" id="cout">$4500.00</span>
                           
                        </div>
                        <div class="pd_dtails">
                            <p id="commentaire">
                                
                            </p>
                        </div>
                       
                        
                    </div>
                    <div class="product_buttons">
                        <a href="#" id="opanier" class="default_btn me-sm-3 me-2 px-2 px-lg-4 d-none"><i
                                class="icon-cart me-2"></i><span id="opaniert"> </span>  </a>
                        <a href="javascript:void(0)" id="aimertBtn" class="default_btn second px-3 px-ms-4"><i class="icon-heart me-2"></i><span id="aimert"> </span>
                            </a>
                    </div>
                    <div class="share_icons footer_icon d-flex">
                    
                    
                        <a href="javascript:void(0)" id="shareObjet" ><i class="fa-solid fa-share-nodes"></i></a>
                        <a href="#"><i class="lab la-facebook-f"></i></a>
                        <a href="#"><i class="lab la-twitter"></i></a>
                        <a href="#"><i class="lab la-instagram"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

  
  `;

  let article_detail = document.createElement('div');
  article_detail.innerHTML = template.trim();

  return article_detail.firstChild;
}




function closepop()
{
console.log("=====---//rwe;ob=ce//---====");
var element = document.getElementById("xoxo");
  element.classList.remove("active");    
    
}


async function seeTerrain(url,id,p,l,t,d,v)
{
console.log(p+"=====---seeTerrain---===="+l);

///url,article,p


 console.log(p+"=====---seeTerrain---===="+localVars);
 let item = createRDVform(url,id,p,localVars);
 
 
 document.getElementById("pop2item").appendChild(item);
 var element = document.getElementById("xoxo");
   element.classList.add("active");
   
   const el = document.getElementById("closepop");
el.addEventListener("click", closepop, false);

 const title = document.getElementById("titre");
title.innerHTML = v+" "+l+" M2 ";

 const commentaire = document.getElementById("commentaire");
commentaire.innerHTML = d;

 var btnConfirmeRdvTxt = document.getElementById("btnConfirmeRdvTxt");
    btnConfirmeRdvTxt.innerHTML = "Confirmer RDV";
       
  const cout = document.getElementById("cout");
cout.innerHTML = moneyFormat(t); 

 const focout = document.getElementById("focout");
 var focoutt = Math.round(t*(1.2));
focout.innerHTML = moneyFormat(focoutt); 

 const opaniert = document.getElementById("opaniert");
opaniert.innerHTML = localVars[8];

const aimertBtn = document.getElementById("aimertBtn")
 aimertBtn.addEventListener("click", function(){
    loveTerrain(url,id,p,l,t);
 });
 const aimert = document.getElementById("aimert");
aimert.innerHTML = localVars[2];

const btnConfirmeRdv = document.getElementById("btnConfirmeRdv");
btnConfirmeRdv.addEventListener("click", function(){
const RDVdate = document.getElementById("RDVdateJS");
const RDVtxt = document.getElementById("RDVtxtJS"); 
var RDVtxtV = RDVtxt.value;
var RDVdateV = RDVdate.value;
    if(RDVdateV.length < 10)
    {
     console.log(RDVdateV.length); 
       Swal.fire(
      ' '+UserInfo[0]+' Votre Date est incorrecte !',
     'utilisez le sélecteur de date',
      'error'
    ).then(console.log(RDVdateV.length))  
    }else
    {

    ConfirmeRdv(url,id,p,l,t,RDVdateV,RDVtxtV);
    }
  
});

 const opanier = document.getElementById("opanier");
opanier.addEventListener("click", function(){
  GopayTerrain(url,id,p,l,t);
});

const shareObjetBtn = document.getElementById("shareObjet");
shareObjetBtn.addEventListener("click", function(){
    var shareObjetUrl = app_url+'T/'+id+'/'+urldecodeSanitaire(l);
  shareObjet(l,d,shareObjetUrl);
}); 

 
 //document.getElementById('pop2item').innerHTML +=  item;


}
async function GopayTerrain(url,id,p,l,t)
{
location.href = PnaierImmoPage+"?immobilier="+id;    
}


async function InitpayTerrain(url,id,p,l,t)
{
var key = token_api_client;
 let item = createRDVform(url,id,p);
 
 //console.log(p+"=====--+++++-//RORO//---===="+id);
 

Swal.fire({
  title: 'Quantité de '+l,
  input: 'number',
  inputLabel: '',
  inputPlaceholder: '1',
  showCloseButton: true,
   confirmButtonText:
    '<i class="fa-solid fa-cart-plus"></i> Ajouter au panier',
      didOpen: () => {
    const input = Swal.getContainer().querySelector('input');
    input.addEventListener('keyup', (e) => {
      
    //Swal.fire(`Entered amount`)
      var QteInput = Swal.getPopup().querySelector('input').value
      if(QteInput == "" || QteInput < 1)
      {
       QteInput = 1;
       
      }
      var estimation = moneyFormat(QteInput*t)
     Swal.showValidationMessage('Total : '+estimation)
      const value = e.detail.value
      Swal.getConfirmButton().disabled = value < 0
    })
  },
    showLoaderOnConfirm: true,
        preConfirm : (val) => {
         //const value = Swal.getContainer().querySelector('input').value;
    //return value < 0 ? Swal.showValidationMessage(localVars[3]) : value;
    
        window.tempQte = val;
    return fetch(app_url+`ajax/client/api.php?req=10&token_api_client=${key}&id=${id}&qte=${val}`)
      .then(response => {
        if (!response.ok) {
            ///statusText
          throw new Error(response.status)
        }
        return response.json()
      })
      .catch(error => {
        Swal.showValidationMessage(
          `Erreur : ${error}`
        )
      })
  },
  allowOutsideClick: () => !Swal.isLoading()
}).then((result) => {
    console.log("====undef==="+result.value);
    
    if(result.value)
    {
    
    if(result.value.r == "noclient")
    {
      console.log(result.value.r);
      location.href = loginPage; 
      return false;
        
    }
    
    if(result.value.r == "noarticle")
    {
      console.log(result.value.r);
     Swal.fire(
  'Article introuvable',
  'Cet article a peut-être été supprimé',
  'error'
)
      return false;
        
    }
    console.log(result.value.contenu.nbr);
   
  if (result.isConfirmed && result.value.r == "ok" ) {
    const boxWrapper = document.getElementById("panier_visuel_web");
    const boxWrapperm = document.getElementById("panier_visuel_webm");
    
const box = document.createElement("div");
const boxm = document.createElement("div");

const child = document.getElementById("paniervide");
const childm = document.getElementById("paniervidem");

  
    if(result.value.contenu.nbr == 1)
    {
    child.remove(); 
    childm.remove();    
    }
    else
    {
        
    }
    
idcp = result.value.contenu.idcp;    
    
p_p3x952 = result.value.contenu.panier;

box.innerHTML = createPanierItem(idcp,IntNotNull(tempQte),p,l,t,app_url,url_article_path);
boxm.innerHTML = createPanierItemm(idcp,IntNotNull(tempQte),p,l,t,app_url,url_article_path);
//box.style.backgroundColor = "orange";
//box.classList.add("box");
boxWrapper.appendChild(box);
boxWrapperm.appendChild(boxm);
//WEB
  const nbrItemsT = document.getElementById("nbrItemsT");
 nbrItemsT.innerHTML =""+result.value.contenu.nbr+" "+accordTxt(localVars[4],result.value.contenu.nbr) ;


  const nbrItemsB = document.getElementById("nbrItemsB");
   nbrItemsB.innerHTML = result.value.contenu.nbr;
   
   const CoutTotalFacturePanier = document.getElementById("CoutTotalFacturePanier");
   CoutTotalFacturePanier.innerHTML = moneyFormat(result.value.contenu.xof);
//MOBILE 

 const nbrItemsTm = document.getElementById("nbrItemsTm");
 nbrItemsTm.innerHTML =""+result.value.contenu.nbr+" "+accordTxt(localVars[4],result.value.contenu.nbr) ;
   
     const nbrItemsBm = document.getElementById("nbrItemsBm");
   nbrItemsBm.innerHTML = result.value.contenu.nbr;


const CoutTotalFacturePanierm = document.getElementById("CoutTotalFacturePanierm");
   CoutTotalFacturePanierm.innerHTML = moneyFormat(result.value.contenu.xof);
   
   setLocalVars("p3x952",enc(String(result.value.contenu.xof)));
   
 
         Swal.fire(
  'Article ajouté',
  'Cet article a été ajouté à votre panier',
  'success'
)



  }
  
  }
  else
  {
    
  }
  
})

//if (val) {
    /////
    
    /////
    
  //Swal.fire(`Entered email: ${qte}`)
//}

}


function PopCommandeStatut(id,type,lib,desc)
{
    Swal.fire({
  title: '<strong>CODE OPR : '+id+' </strong>',
  html: '<p>'+lib+'</p><br /><p>'+desc+'</p>',
  icon: 'success'
})

}


async function ConfirmeRdv(url,id,p,l,t,RDVdate,RDVtxt)
{
    var key = token_api_client;
    const params = {
    id:id,
    RDVdate: RDVdate,
    RDVtxt: RDVtxt 
};
const options = {
    method: 'POST',
    body: JSON.stringify(params)  
};
    
    fetch(app_url+`ajax/client/api.php?req=7&token_api_client=${key}&id=${id}`,options)
        .then((response) => {
            if(!response.ok){ // Before parsing (i.e. decoding) the JSON data,
                              // check for any errors.
                // In case of an error, throw.
                throw new Error("Something went wrong!");
            }

            return response.json(); // Parse the JSON data.
        })
        .then((data) => {
             // This is where you handle what to do with the response.
             //alert(data.rdv); // Will alert: 42
             if(data.rdv == "1")
             {
               Swal.fire(
      ' '+UserInfo[0]+' Votre rendez-vous a été validé avec succès !',
     'Vous serez contacté par un commercial pour plus de détails',
      'success'
    ).then()  
             }else
             {
             Swal.fire(
      ' '+UserInfo[0]+' vous avez déjà un rendez-vous validé pour ce terrain !',
     'Vous serez contacté par un commercial pour plus de détails',
      'info'
    ).then()      
             }
        })
        .catch((error) => {
                  Swal.fire(
      ' '+UserInfo[0]+' vérifiez votre connexion internet !',
     'Vous serez contacté par un commercial pour plus de détail après avoir validé votre rendez-vous',
      'error'
    ).then()
             console.error('Error:', error);
             // This is where you handle errors.
        });
    
}




async function loveTerrain(url,id,p,l,txt)
{
        const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})

     var key =  token_api_client; 
        fetch(app_url+`ajax/client/api.php?req=8&token_api_client=${key}&id=${id}`)
        .then((response) => {
            if(!response.ok){ // Before parsing (i.e. decoding) the JSON data,
                              // check for any errors.
                // In case of an error, throw.
                throw new Error("Something went wrong!");
            }

            return response.json(); // Parse the JSON data.
        })
        .then((data) => {
             // This is where you handle what to do with the response.
             //alert(data.r); // Will alert: 42
             if(data.r == "oui")
             {
                
                
             Toast.fire({
  icon: 'success',
  title: 'J\'aime'
})   
                
                
             }
             else
             {
                Toast.fire({
  icon: 'success',
  title: 'J\'aime déjà'
})
                
             }
        })
        .catch((error) => {
        errorPage();
             // This is where you handle errors.
        });
    



}




function createPanierVide________($ecran) /// A SUpprimer
{
var lv5 = localVars[5];
var lv6 = localVars[6];
if($ecran == "web")
{
var textContent = `<a href="#" class="single_cartdrop" id="paniervide">
                                  
                                    <div class="cartdrop_img">
                                        <img loading="lazy"  src="../article/panier.jpg" alt="product">
                                    </div>
                                    <div class="cartdrop_cont">
                                        <h5 class="text_lg mb-0 default_link">
                                           ${lv5}
                                        </h5>
                                        <p class="mb-0 text_xs text_p"> ${lv6}  <span class="ms-2"></span></p>
                                    </div>
                                </a>
                                `;    
}
else
{
    var textContent = `<a href="#" class="single_cartdrop" id="paniervidem">
                                  
                                    <div class="cartdrop_img">
                                        <img loading="lazy"  src="../article/panier.jpg" alt="product">
                                    </div>
                                    <div class="cartdrop_cont">
                                        <h5 class="text_lg mb-0 default_link">
                                           ${lv5}
                                        </h5>
                                        <p class="mb-0 text_xs text_p"> ${lv6} <span class="ms-2"></span></p>
                                    </div>
                                </a>
                                `;
    
}
    
    return textContent;
    
}


function filtre_par_ville_________________________(id)
{
    //window.searchCout = "plus";
 var x = document.getElementById("filtre_par_cout");
 

  //x.value = x.value.toUpperCase();
  if(x.value == "no")
  {
   window.location.href = searchCoutPage+"&searchVille="+id;
  //alert(x.value);  
  }
  else
  {
   window.location.href = searchCoutPage+"&searchCoutPage="+x.value+"&searchVille="+id;
  //alert(x.value);  
  }
 
     
}

function filtre_par_ville_mobile___________________________(id)
{
    //window.searchCout = "plus";
 var x = document.getElementById("filtre_par_cout");
 

  //x.value = x.value.toUpperCase();
  if(x.value == "no")
  {
   window.location.href = searchCoutPage+"&searchVille="+id;
  //alert(x.value);  
  }
  else
  {
   window.location.href = searchCoutPage+"&searchCoutPage="+x.value+"&searchVille="+id;
  //alert(x.value);  
  }
 
     
}

function filtre_par_cout_mobile_______________()
{
    //window.searchCout = "plus";
 var x = document.getElementById("filtre_par_cout_mobile");
  //x.value = x.value.toUpperCase();
  window.location.href = searchCoutPage+"&searchCoutPage="+x.value;
  //alert(x.value);
     
}

function openImmobilier(url,id,p,l,v,t,d)
{
if(t > 0)
{
var txt = "coool";
Swal.fire({
  title: `<div class="pt-3 text-center"> ${l+" "+accord(l,'PIECE').toUpperCase()+" "}<br /><span class="">${v}</span> <br /></div>`,
  html:  `<div class="pt-3 text-center"> ${sanctificationLITEdec(d)} <br /> <br /> Prix : ${moneyFormat(t)} </div>`,
  showDenyButton: true,
  showCancelButton: false,
   showCloseButton: true,
  confirmButtonText:`<i class="fa-solid fa-cart-plus"></i> `+ localVars[9],
  denyButtonText: "RDV pour visiter",
  customClass: {
    actions: 'my-actions',
    //cancelButton: 'order-1 right-gap',
    confirmButton: 'order-2',
    denyButton: 'order-3',
  }
}).then((result) => {
  if (result.isConfirmed) {
    if(U_sCode == "NULL")
    {
    location.href = loginPage ;     
    }
    else
    {
       GopayTerrain(url,id,p,l,t);   
    }
   
  } else if (result.isDenied) {
     if(U_sCode == "NULL")
    {
    location.href = loginPage;     
    }
    else
    {
    seeTerrain(url,id,p,l,t,d,v);
    //qteOpen();
    }
  }
})
    
}
else
{
    
}


}




function openTerrain(url,id,p,l,v,t,d)
{
if(t > 0)
{
var txt = "coool";
Swal.fire({
  title: `<div class="pt-3 text-center"> ${l+" M2 "}<br /><span class="">${v}</span> <br /></div>`,
  html:  `<div class="pt-3 text-center"> ${sanctificationLITEdec(d)} <br /> <br /> Prix : ${moneyFormat(t)} </div>`,
  showDenyButton: true,
  showCancelButton: false,
   showCloseButton: true,
  confirmButtonText:`<i class="fa-solid fa-cart-plus"></i> `+ localVars[9],
  denyButtonText: "RDV pour visiter",
  customClass: {
    actions: 'my-actions',
    //cancelButton: 'order-1 right-gap',
    confirmButton: 'order-2',
    denyButton: 'order-3',
  }
}).then((result) => {
  if (result.isConfirmed) {
    if(U_sCode == "NULL")
    {
    location.href = loginPage ;     
    }
    else
    {
       GopayTerrain(url,id,p,l,t);   
    }
   
  } else if (result.isDenied) {
     if(U_sCode == "NULL")
    {
    location.href = loginPage;     
    }
    else
    {
    seeTerrain(url,id,p,l,t,d,v);
    //qteOpen();
    }
  }
})
    
}
else
{
    
}


}





function filtreSearch________________________________()
{

let params = new URLSearchParams(document.location.search);
let operation = params.get("operation"); // is the string "Jonathan"
let searchCout = params.get("searchCoutPage");
  console.log(operation);
 var operationTXT = "vente";
 var searchCoutTXT = "NULL";
 var searchVilleTreat = "r_";
    //window.searchCout = "plus";
 var x = document.getElementById("filtreSearch"); 
  //x.value = x.value.toUpperCase();
  if(operation)
  {
  operationTXT = operation;
   
  }
  
    if(searchCout)
  {
   searchCoutTXT = searchCout;
  //window.location.href = searchCoutPage+"&searchCoutPage="+x.value+"&searchVille="+searchVilleTreat;
    
  }
   if(searchVille.length > 2)
  {
  searchVilleTreat = searchVille.slice(searchVille.indexOf('r_') + 2);
  //window.location.href = searchCoutPage+"&searchCoutPage="+x.value+"&searchVille="+searchVilleTreat;
    
  }
 
   window.location.href =  searchCoutPage+"&operation="+operationTXT+"&earchCoutPage="+x.value+"&searchVille="+searchVilleTreat;
  
     
}

async function PubCall(){
if(pubAutoState)
{
window.setInterval(function(){

    var Rand =  Math.floor(Math.random() * pubAuto.length);
       
    document.getElementById("resultat_total_api").innerHTML = pubAuto[Rand] ; 
    document.getElementById("resultat_total_apiM").innerHTML = pubAuto[Rand].substring(0,35)+"..." ;
    //console.log("===============   PUB "+Rand);   
}, 5000);

}
}

function accord(qte,txt)
{
var texte = "";
if(qte > 1)
{
texte = txt+"s";    
} 
else
{
texte = txt;    
}
return texte;
}

function selectElement(id, valueToSelect) {    
    let element = document.getElementById(id);
    element.value = valueToSelect;
}

function checkedElement(id, checked) { 
if(id)
{
  var element = document.getElementById(id);
   if(checked == "checked")
   {
   element.setAttribute("checked", checked);  
   }   
}
else
{
    
}
   
   
   
    
}

function checkGetmontant(montant,id,moneyF)
{

 var params = new URLSearchParams(document.location.search);
   var cout = params.get(id);
  // let coutf = params.get("coutf");
   var retCout = 5000;
   //console.log( " ==INI ! =>"+cout );
                if(cout)
                {
                // console.log( " ==1 !" );
                if(moneyF)
                {
                 //   console.log( " ==2 !" );
                retCout = moneyFormat(cout);    
                }
                else
                {
                //    console.log( " ==3 !" );
                retCout = cout;    
                }
                
    
                }
                else
                {
                 //   console.log( " ==4 !" );
                retCout = montant   
                }
                //console.log( " ==5 !"+moneyF );
          return retCout;    
}

function checkGetNumber(montant,id,moneyF)
{

 var params = new URLSearchParams(document.location.search);
   var cout = params.get(id);
  // let coutf = params.get("coutf");
   var retCout = 5000;
   //console.log( " ==INI ! =>"+cout );
                if(cout)
                {
                // console.log( " ==1 !" );
                if(moneyF)
                {
                 //   console.log( " ==2 !" );
                retCout = numberFormat(cout);    
                }
                else
                {
                //    console.log( " ==3 !" );
                retCout = cout;    
                }
                
    
                }
                else
                {
                 //   console.log( " ==4 !" );
                retCout = montant   
                }
                //console.log( " ==5 !"+moneyF );
          return retCout;    
}


function SubmitRDV(url,id,p,l,t)
{
      
       
    const RDVdate = document.getElementById("RDVdate");
    const RDVtxt = document.getElementById("RDVtxt"); 
    var RDVtxtV = RDVtxt.value;
    var RDVdateV = RDVdate.value;
    if(RDVdateV.length < 10)
    {
     console.log(RDVdateV.length); 
       Swal.fire(
      ' '+UserInfo[0]+' Votre Date est incorrecte !',
     'utilisez le sélecteur de date',
      'error'
    ).then(console.log(RDVdateV.length))  
    }else
    {
    ConfirmeRdv(url,id,p,l,t,RDVdateV,RDVtxtV);
    }
    
    
}


async function stockPanier(url,id,txt)
{
        const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})

     var key =  token_api_client; 
        fetch(app_url+`ajax/client/api.php?req=8&token_api_client=${key}&id=${id}`)
        .then((response) => {
            if(!response.ok){ // Before parsing (i.e. decoding) the JSON data,
                              // check for any errors.
                // In case of an error, throw.
                throw new Error("Something went wrong!");
            }

            return response.json(); // Parse the JSON data.
        })
        .then((data) => {
             // This is where you handle what to do with the response.
             //alert(data.r); // Will alert: 42
             if(data.r == "oui")
             {
                
                
             Toast.fire({
  icon: 'success',
  title: 'J\'aime'
})   
                
                
             }
             else
             {
                Toast.fire({
  icon: 'success',
  title: 'J\'aime déjà'
})
                
             }
        })
        .catch((error) => {
        errorPage();
             // This is where you handle errors.
        });


}

function PanierContenu(id) /////////// DELETE
{
                 Toast.fire({
  icon: 'success',
  title: 'J\'aime déjà'
})   
    
}


//console.log("YYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYY"+checkGetmontant(500000,"coutf",false));


//////////////////////// JQUERRY PART /////////////////////////////////////

(function ($) {
  
        
        $(document).ready(function() {
        PubCall();
        


  
    
    if(BoutiqueFormRefresh)
    {
        
        
        // console.log( " BoutiqueFormRefresh !" );
                let params = new URLSearchParams(document.location.search);
                let searchCout = params.get("searchCoutPage");
                let typeA1 = params.get("typeA1");
                let typeA2 = params.get("typeA2");
                let typeA3 = params.get("typeA3");
                let genreA1 = params.get("genreA1");
                let genreA2 = params.get("genreA2");
                let couti = params.get("couti");
                let coutf = params.get("coutf");
                
                if(searchCout != "NULL")
                {
                
                 selectElement('filtre_par_cout', searchCout);   
                }
                
                if(typeA1 != "NULL")
                {
                
                 checkedElement(typeA1, "checked");
                 checkedElement(typeA2, "checked"); 
                 checkedElement(typeA3, "checked"); 
                 
                }
                
                if(genreA1 != "NULL")
                {
                
                 checkedElement(genreA1, "checked");
                 checkedElement(genreA2, "checked"); 
                 
                }
              
                
                
    }
    
    
    
});  



       $('[name="checkreserve"]').change(function()
      {
          console.log("OKKJJJJ NO");
        if ($(this).is(':checked')) {
           // Do something...
           var text = infoReservationtxt;
            infoBox("warning",infoReservationTitre,text, "");
            const BtnReserveDiv = document.getElementById('BtnReserveDiv');
            const BtnReserve = document.getElementById('BtnReserve');    
                  
              
                    BtnReserveDiv.classList.remove('btnDesable');
                 document.getElementById("BtnReserve").disabled = false;
              
           //alert('You OKOKOK can rock now...');
        }else
        {
          
           const BtnReserveDiv = document.getElementById('BtnReserveDiv');
               document.getElementById("BtnReserve").disabled = true;  
                  
              
                   BtnReserveDiv.classList.add('btnDesable');
        }
      });
    
    
    
    
 
    
  
     $('[name="checkapport"]').change(function()
      {
        console.log("OKKJJJJ");
        if ($(this).is(':checked')) {
           // Do something...
           var MontantFinal = montantActuelTmp*PourcentActuelTmp;
           montantActuelTmp = MontantFinal;
            $('.cout_total').html(moneyFormat(MontantFinal));
           //alert('You OKOKOK can rock now...');
        }else
        {
          
           montantActuelTmp = IDMontantTmp;
            var MontantFinal = montantActuelTmp;
          $('.cout_total').html(moneyFormat(MontantFinal));
        }
      });
      
      
      
      
      
      
      
      /////
       $('#filtreSearch________________________________').change(function()
      {
                var thisID = $(this).attr('id');
                var thisSelectedVal =  $('option:selected',this).val();
                
                let params = new URLSearchParams(document.location.search);
                let operation = params.get("operation"); // is the string "Jonathan"
                let searchCout = params.get("searchCoutPage");
                let searchVille = params.get("searchVille");
                  console.log(operation);
                 var operationTXT = "vente";
                 var searchCoutTXT = "NULL";
                 var searchVilleTXT = "r_";
                 var villeSuiteLk = "";
                    //window.searchCout = "plus";
                 //var x = document.getElementById("filtreSearch"); 
                  //x.value = x.value.toUpperCase();
                  
                  if(operation)
                  {
                  operationTXT = operation;
                   
                  }
                  
                    if(searchCout)
                  {
                   //searchCoutTXT = searchCout;
                  //window.location.href = searchCoutPage+"&searchCoutPage="+x.value+"&searchVille="+searchVilleTreat;
                    
                  }
                   if(searchVille)
                  {
                  searchVilleTreat = searchVille.slice(searchVille.indexOf('r_') + 2);
                  searchVilleTXT = searchVille.slice(searchVille.indexOf('r_') + 2);
                  villeSuiteLk = "&searchVille="+searchVille; 
                  //window.location.href = searchCoutPage+"&searchCoutPage="+x.value+"&searchVille="+searchVilleTreat;
                    
                  }
                 
                   window.location.href =  searchCoutPage+"&operation="+operationTXT+"&searchCoutPage="+thisSelectedVal+villeSuiteLk;
                  
    
        
       
       
       
      });
      
        $(function () {
        $("#dimensionT-range").slider({
            range: true,
            min: 1,
            max: 10000,
            values: [checkGetmontant(1,"dimi",false),checkGetmontant(10000,"dimf",false)],
            slide: function (event, ui) {
                $("#amountdim").val("" + ui.values[0] + " - " + ui.values[1]+" m2");
            }
        });
        $("#amountdim").val(" " + checkGetmontant($("#dimensionT-range").slider("values", 0),"dimi",false) +
            " - " + checkGetmontant($("#dimensionT-range").slider("values", 1),"dimf",false)+" m2");
    });
       
        
      $(function () {
        $("#mise-en-valeur-range").slider({
            range: true,
            min: 1,
            max: 100,
            values: [checkGetmontant(1,"pmevi",false),checkGetmontant(100,"pmevf",false)],
            slide: function (event, ui) {
                $("#amountmev").val("" + ui.values[0] + " - " + ui.values[1]+" %");
            }
        });
        $("#amountmev").val(" " + checkGetmontant($("#mise-en-valeur-range").slider("values", 0),"pmevi",false) +
            " - " + checkGetmontant($("#mise-en-valeur-range").slider("values", 1),"pmevf",false)+" %");
    });
    ////////////////////////////////////////////////////////////////////////////////////////////
      $(function () {
        $("#cout-range").slider({
            range: true,
            min: 1,
            max: 100000000000,
            values: [checkGetmontant(1,"couti",false),checkGetmontant(100000000000,"coutf",false)],
            slide: function (event, ui) {
                $("#amountCout").val("" + ui.values[0] + " - " + moneyFormat(ui.values[1])+" ");
            }
        });
            
            $("#amountCout").val(" " + checkGetmontant($("#cout-range").slider("values", 0),"couti",true) +
            " - " + checkGetmontant($("#cout-range").slider("values", 1),"coutf",true)+"");
    });
    //////////////////////////////////  ///// BOUTIQUE JQUERRY

          $(function () {
        $("#cout-rangeboutique").slider({
            range: true,
            min: 1,
            max: 500000,
            values: [checkGetmontant(1,"couti",false),checkGetmontant(500000,"coutf",false)],
            slide: function (event, ui) {
                $("#amountCoutB").val("" + ui.values[0] + " - " + moneyFormat(ui.values[1])+" ");
            }
        });
        $("#amountCoutB").val(" " + checkGetmontant($("#cout-rangeboutique").slider("values", 0),"couti",true) +
            " - " + checkGetmontant($("#cout-rangeboutique").slider("values", 1),"coutf",true)+"");
    });  
    
   
    ////////////////// Immobilier
         $(function () {
        $("#dimension-range").slider({
            range: true,
            min: 1,
            max: 50000,
            values: [checkGetNumber(1,"couti",false),checkGetNumber(50000,"coutf",false)],
            slide: function (event, ui) {
                $("#valeur_dimension").val("" + ui.values[0] + " - " + numberFormat(ui.values[1])+" M2");
            }
        });
        $("#valeur_dimension").val(" " + checkGetNumber($("#dimension-range").slider("values", 0),"couti",true) +
            " - " + checkGetNumber($("#dimension-range").slider("values", 1),"coutf",true)+"");
    });
    
    
    ////////////////////////////
function create() {
  var counter = 5;
  return {
    increment: function() {
      counter++;
       console.log( counter );
    },
    print: function() {
      console.log( counter );
    }
  }
}
   //var c = create();
        
       // searchVille = c.increment();  

function traiteVars(txt) {
     var txtf = "";
    if(txt == "" || txt == undefined)
    {
     txtf = "NULL";   
    }
    else
    {
     txtf = txt;   
    }
  return txtf ;
  
}

 //fetch(app_url+`ajax/client/api.php?req=8&token_api_client=${key}&id=${id}

function DateLivraisonPanier(id)
{
 Swal.fire({
 // title:`  ${lastprenom} maintenant, choisissez votre date de livraison`,
  //input: "text",
    html: `  ${lastprenom} maintenant, choisissez votre date de livraison <br />
    <input id="swal-input1" type="date" class="swal2-input">

  `,
  inputAttributes: {
    autocapitalize: "off"
  },
  showCancelButton: false,
  showCloseButton: true,
  confirmButtonText: "Valider",
  showLoaderOnConfirm: true,
  preConfirm: async (login) => {
    dateOpr = document.getElementById("swal-input1").value;
     var key =  token_api_client;
     var Postdata = {"dateOpr":dateOpr};
     var  Postdatas = JSON.stringify(Postdata);
      if(dateOpr.length == "0")
     {
       return false; 
     }
     
    try {
      const githubUrl = `${app_url}ajax/client/api.php?req=11&token_api_client=${key}&id=${id}
      `;
      const response = await fetch(githubUrl, { method: "POST", body: Postdatas });
      if (!response.ok) {
        return Swal.showValidationMessage(`
          ${JSON.stringify(await response.json())}
        `);
      }
      return response.json();
    } catch (error) {
      Swal.showValidationMessage(`
        Request failed: ${error}
      `);
    }
  },
  allowOutsideClick: () => !Swal.isLoading()
}).then((result) => {
  if (result.isConfirmed) {
    Swal.fire({
      title: "Livraison programmée",
      text: lastprenom+", votre livraison a été programmée avcec succès.",
      icon: "success"
    });
  }
});   
}


function DateStockagePanier(id)
{
 Swal.fire({
 // title:`  ${lastprenom} maintenant, choisissez votre date de livraison`,
  //input: "text",
    html: `  ${lastprenom} maintenant, choisissez votre date limite de stockage. Vous souhaitez que notre agence stock votre commande ${id} jusqu'a quelle date ? Vous aurez 6 mois maximum <br />
    <input id="swal-input1" type="date" class="swal2-input">

  `,
  inputAttributes: {
    autocapitalize: "off"
  },
  showCancelButton: false,
  showCloseButton: true,
  confirmButtonText: "Valider",
  showLoaderOnConfirm: true,
  preConfirm: async (login) => {
    dateOpr = document.getElementById("swal-input1").value;
    
    //console.log(dateOpr.length+"===OOOO==="+dateOpr);
     var key =  token_api_client;
     var Postdata = {"dateOpr":dateOpr};
     var  Postdatas = JSON.stringify(Postdata);
     if(dateOpr.length == "0")
     {
       return false; 
     }
    try {
      const githubUrl = `${app_url}ajax/client/api.php?req=12&token_api_client=${key}&id=${id}
      `;
      const response = await fetch(githubUrl, { method: "POST", body: Postdatas });
      if (!response.ok) {
        return Swal.showValidationMessage(`
          ${JSON.stringify(await response.json())}
        `);
      }
      return response.json();
    } catch (error) {
      Swal.showValidationMessage(`
        Request failed: ${error}
      `);
    }
  },
  allowOutsideClick: () => !Swal.isLoading()
}).then((result) => {
  if (result.isConfirmed) {
    Swal.fire({
      title: "Stockage programmé"+result.value.r,
      text: lastprenom+", nous acceptons volontier de sotcker votre commande "+id+" jusqu'a cette date. Retrouvez cette commande dans la rubrique de vos commandes stockées",
      icon: "success"
    });
  }
});   
}



      
      
         $('#filtreBtn').click(function()
      {
        let searchPrice = $('option:selected','#filtre_par_cout_mobile').val();
        let commune = $('option:selected','#commune').val();
        let lotissement = $('option:selected','#lotissement').val();
        let st_via = $('option:selected','#st_viabilisation').val();
        let st_lot = $('option:selected','#st_lotissement').val();
        let titre_prop = $('option:selected','#titre_prop').val();
        let pmevi = $("#mise-en-valeur-range").slider("values", 0);
        let pmevf = $("#mise-en-valeur-range").slider("values", 1);
        
        let dimi = $("#dimensionT-range").slider("values", 0);
        let dimf = $("#dimensionT-range").slider("values", 1);
        
        let couti = $("#cout-range").slider("values", 0);
        let coutf = $("#cout-range").slider("values", 1);
        
        
        console.log("rechercher_par_filtre");
        var newval0 = 10;
        var newval1 = 70
        
       
        //$("#mise-en-valeur-range").slider("values", 1,newval1);
        //$("#mise-en-valeur-range").val(50);
        //$("#amountmev").val("" + newval0 + " - " + newval1+" %");
          window.location.href =  searchCoutPage+"&searchCoutPage="+traiteVars(searchPrice)+"&commune="+traiteVars(commune)+"&lotissement="+traiteVars(lotissement)+"&st_via="+traiteVars(st_via)+"&st_lot="+traiteVars(st_lot)+"&titre_prop="+traiteVars(titre_prop)+"&dimi="+traiteVars(dimi)+"&dimf="+traiteVars(dimf)+"&pmevi="+traiteVars(pmevi)+"&pmevf="+traiteVars(pmevf)+"&couti="+traiteVars(couti)+"&coutf="+traiteVars(coutf);
        
      });
      
        $('#filtreBtnImmoVente').click(function()
      {
        let searchPrice = $('option:selected','#filtre_par_cout').val();
        let searchVille = $('option:selected','#commune').val();
        let quartier = $('option:selected','#quartier').val();
        let nbr_piece = $('option:selected','#nbr_piece').val();
        let type_local = $('option:selected','#type_local').val();
        let type_construction = $('option:selected','#type_construction').val();
        
        
        let pmevi = $("#mise-en-valeur-range").slider("values", 0);
        let pmevf = $("#mise-en-valeur-range").slider("values", 1);
        
        let couti = $("#cout-range").slider("values", 0);
        let coutf = $("#cout-range").slider("values", 1);
        
        let params = new URLSearchParams(document.location.search);
        let operation = params.get("operation");
                
                
                
          window.location.href =  searchCoutPage+"&operation="+operation+"&searchPrice="+traiteVars(searchPrice)+"&searchVille="+traiteVars(searchVille)+"&quartier="+traiteVars(quartier)+"&nbr_piece="+traiteVars(nbr_piece)+"&type_local="+traiteVars(type_local)+"&type_construction="+traiteVars(type_construction)+"&pmevi="+traiteVars(pmevi)+"&pmevf="+traiteVars(pmevf)+"&couti="+traiteVars(couti)+"&coutf="+traiteVars(coutf);
        
      });
      
      
            
        $('#filtreBtnImmoLocaltion').click(function()
      {
        let searchPrice = $('option:selected','#filtre_par_cout').val();
        let searchVille = $('option:selected','#ville').val();
        let quartier = $('option:selected','#quartier').val();
        let nbr_piece = $('option:selected','#nbr_piece').val();
        let type_local = $('option:selected','#type_local').val();
        let type_construction = $('option:selected','#type_construction').val();
        let pmevi = $("#mise-en-valeur-range").slider("values", 0);
        let pmevf = $("#mise-en-valeur-range").slider("values", 1);
        
        let couti = $("#cout-range").slider("values", 0);
        let coutf = $("#cout-range").slider("values", 1);
        
        let params = new URLSearchParams(document.location.search);
        let operation = params.get("operation");
                
                
                
          window.location.href =  searchCoutPage+"&operation="+operation+"&searchPrice="+traiteVars(searchPrice)+"&searchVille="+traiteVars(searchVille)+"&quartier="+traiteVars(quartier)+"&nbr_piece="+traiteVars(nbr_piece)+"&type_local="+traiteVars(type_local)+"&type_construction="+traiteVars(type_construction)+"&pmevi="+traiteVars(pmevi)+"&pmevf="+traiteVars(pmevf)+"&couti="+traiteVars(couti)+"&coutf="+traiteVars(coutf);
        
      });
      
      
      
      
      
      $('#filtreBtnBoutique').click(function()
      {
        let searchPrice = $('option:selected','#filtre_par_cout').val();
        
        var parentDiv_type_article = [];
        $("#type_article > input:checked").each((index, elem) => {
        parentDiv_type_article.push(elem.id);
        });
        
        let typeA1 = parentDiv_type_article[0];
        let typeA2 = parentDiv_type_article[1];
        let typeA3 = parentDiv_type_article[2];
        
         var parentDiv_genre_article = [];
        $("#genre_article > input:checked").each((index, elem) => {
        parentDiv_genre_article.push(elem.id);
        });
        
        let genreA1 = parentDiv_genre_article[0];
        let genreA2 = parentDiv_genre_article[1];
       
        let couti = $("#cout-rangeboutique").slider("values", 0);
        let coutf = $("#cout-rangeboutique").slider("values", 1);
      
          window.location.href =  searchCoutPage+"&searchCoutPage="+traiteVars(searchPrice)+"&typeA1="+traiteVars(typeA1)+"&typeA2="+traiteVars(typeA2)+"&typeA3="+traiteVars(typeA3)+"&genreA1="+traiteVars(genreA1)+"&genreA2="+traiteVars(genreA2)+"&couti="+traiteVars(couti)+"&coutf="+traiteVars(coutf);
        
      });
      
      
      
         $('.StockPanier').click(function()
      {
        var id_article = $(this).attr('id');
Swal.fire({
  //title: "<strong>HTML <u>example "+id_article+"</u></strong>",
  icon: "",
  html: ` ${lastprenom}, que voulez-vous faire du panier ${id_article} ?
   `,
  showCloseButton: true,
  showCancelButton: false,
  showDenyButton: true,
  focusConfirm: true,
  confirmButtonText: `<i class="fa-solid fa-box-archive"></i> Stocker`,
  confirmButtonAriaLabel: "Stocker",
  denyButtonText:  `<i class="fa-solid fa-truck"></i> Livrer `,
  cancelButtonText: `
    <i class="fa fa-thumbs-down"></i> tyttty tytytt ty ty
  `,
  cancelButtonAriaLabel: "Thumbs down"
  
}).then((result) => {
  if (result.isConfirmed) {
    if(id_article == "NULL")
    {
    //location.href = loginPage ;     
    }
    else
    {
     DateStockagePanier(id_article);
    }
   
  } else if (result.isDenied) {
     if(id_article == "NULL")
    {
    //location.href = loginPage;     
    }
    else
    {
    DateLivraisonPanier(id_article);
   
  
    }
  }
})


        
      });
      
      
     $('#PanierContenu').on('click', function(){
         console.log("fffioioioioioioioiofffff"); 
    }) 

      
      
     
      
      
    //
})(jQuery); 



